export default function Chip({ children, color, icon, style }) {
  return (
    <span className="mono" style={{
      display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 11, letterSpacing: '0.1em',
      textTransform: 'uppercase', fontWeight: 600, padding: '5px 10px', borderRadius: 'var(--r-sm)',
      color: color || 'var(--fg-soft)',
      background: color ? `${color}1a` : 'rgba(255,255,255,0.05)',
      border: `1px solid ${color ? color + '40' : 'var(--line)'}`,
      ...style,
    }}>
      {icon}{children}
    </span>
  );
}
